/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Condition from './Condition';
import { connect } from 'react-redux';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Select, message, Input, TreeSelect, Button, Form, Tabs, Tooltip } from 'antd';

import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { GetDefaultHierarchy } from '../APICalls';
import { API_HIERARCHYMODULE } from '../../../commons/api';
import { StyledHomepage } from '../../../commons/styles/layout';
import { deleteStatusRecord, getStatusList, saveLandingPageConfiguration } from './apicalls';

const { TreeNode } = TreeSelect;

const Operator = [
  {
    label: 'EqualTo (==)',
    value: '=='
  },
  {
    label: 'Not EqualTo (!=)',
    value: '!='
  },
  {
    label: 'Greater Than (>)',
    value: '>'
  },
  {
    label: 'Less Than (<)',
    value: '<'
  },
  {
    label: 'Greater Than Or EqualTo (>=)',
    value: '>='
  },
  {
    label: 'Less Than Or EqualTo (<=)',
    value: '<='
  }
];

const StatusConfiguration = () => {
  const [activeKey, setActiveKey] = useState('LIST');
  const [ifConditionList, setIfConditionList] = useState([
    {
      L1: {
        Device: undefined,
        Parameter: undefined,
        Operator: undefined,
        Value: undefined,
        RowType: 'CONDITION'
      },
      L2: {
        RowType: 'RETURN',
        Value: undefined
      }
    }
  ]);
  const [scripts, setScripts] = useState([
    {
      Script: '',
      Priority: 1
    }
  ]);
  const [assetValue, setAssetValue] = useState(undefined);
  const [assetType, setAssetType] = useState('');
  const [datasource, setDatasource] = useState([]);
  const [assetList, setAssetList] = useState([]);
  const [HierarchyCode, setHierarchyCode] = useState('');
  // const [translationCache, setTranslationCache] = useState(props.translationCache);
  useEffect(() => {
    getAssetList();
    getList();
  }, []);
  // useEffect(() => {
  //      if (props.translationCache !== translationCache) {
  //        setTranslationCache(props.translationCache);
  //      }
  //    }, [props.translationCache, translationCache]);

  const getAssetList = async () => {
    let module = 'RS';
    let defaultHiearchyCode = await GetDefaultHierarchy();
    let HierarchyCode =
      defaultHiearchyCode && defaultHiearchyCode[0] && defaultHiearchyCode[0].HierarchyCode
        ? defaultHiearchyCode[0].HierarchyCode
        : '';
    let assetList = await getAssetListForStatusConfiguration(HierarchyCode, module);
    setAssetList(assetList);
    setHierarchyCode(HierarchyCode);
  };

  const getAssetListForStatusConfiguration = (HierarchyCode, module) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'GET',
      url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?SiteId=${siteId}&HierarchyCode=${HierarchyCode}&LevelType=Device&Type=LevelWiseHierarchy&Module=${module}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err.response.status === 400) {
          message.info(err.response.data.message);
        }
      });
  };

  const generateScript = (ifCondition) => {
    let condition =
      ifCondition &&
      Object.keys(ifCondition) &&
      Object.keys(ifCondition).reduce((total, rowKey) => {
        let row = ifCondition[rowKey];
        if (row['RowType'] === 'CONDITION') {
          return total.concat(`(data["${row.Parameter}"]${row.Operator}${row.Value})`);
        } else if (row['RowType'] === 'OPERATOR') {
          return total.concat(row.Value);
        } else {
          return total;
        }
      }, '');

    let returnCondition = ifCondition ? ifCondition[Object.keys(ifCondition).pop()] : {};
    let script = `if(` + condition + `){ return "` + returnCondition.Value + `"}`;
    return script;
  };

  const getList = async () => {
    let datasource = await getStatusList();
    setDatasource(datasource);
  };

  const renderAssetTreeNodes = (data) =>
    data &&
    Array.isArray(data) &&
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode
            value={item.Code}
            title={item.Name}
            key={item.Code}
            dataRef={item}
            type={item.Type}
          >
            {renderAssetTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode value={item.Code} key={item.Code} title={item.Name} type={item.Type} {...item} />
      );
    });

  const onSelectChange = (value, rowKey, ifIndex, key) => {
    let newIfConditionList = [...ifConditionList];
    newIfConditionList[ifIndex] = {
      ...newIfConditionList[ifIndex],
      [rowKey]: {
        ...newIfConditionList[ifIndex][rowKey],
        [key]: value
      }
    };
    setIfConditionList(newIfConditionList);
  };

  const deleteCondition = (ifIndex, index) => {
    let newIfConditionList = [...ifConditionList];
    let ifCondition = newIfConditionList[ifIndex];
    delete ifCondition[`L${index}`];
    delete ifCondition[`L${index + 1}`];
    newIfConditionList[ifIndex] = ifCondition;
    setIfConditionList(newIfConditionList);
  };

  const addNewCondition = (ifIndex) => {
    let newIfConditionList = [...ifConditionList];
    let ifCondition = newIfConditionList[ifIndex];
    let lastCondition = ifCondition ? ifCondition[Object.keys(ifCondition).pop()] : {};
    let rowKeysList = Object.keys(ifCondition);
    delete ifCondition[rowKeysList[rowKeysList.length - 1]];
    ifCondition = {
      ...ifCondition,
      [`L${Object.keys(ifCondition).length + 1}`]: {
        RowType: 'OPERATOR',
        Value: '&&'
      },
      [`L${Object.keys(ifCondition).length + 2}`]: {
        Device: undefined,
        Parameter: undefined,
        Operator: undefined,
        Value: undefined,
        RowType: 'CONDITION'
      },
      [`L${Object.keys(ifCondition).length + 3}`]: lastCondition
    };
    newIfConditionList[ifIndex] = ifCondition;
    setIfConditionList(newIfConditionList);
  };

  const addNewIfCodition = () => {
    let newIfConditionList = [...ifConditionList];
    let newScripts = [...scripts];

    newIfConditionList.push({
      L1: {
        Device: undefined,
        Parameter: undefined,
        Operator: undefined,
        Value: undefined,
        RowType: 'CONDITION'
      },
      L2: {
        RowType: 'RETURN',
        Value: undefined
      }
    });

    newScripts.push({
      Script: '',
      Priority: newScripts.length + 1
    });

    setIfConditionList(newIfConditionList);
    setScripts(newScripts);
  };

  const deleteIfCondition = (ifIndex) => {
    let newIfConditionList = [...ifConditionList];
    let newScripts = [...scripts];

    newIfConditionList.splice(ifIndex, 1);
    newScripts.splice(ifIndex, 1);

    setIfConditionList(newIfConditionList);
    setScripts(newScripts);
  };

  const findCondition = (ifConditionList) => {
    let status = '';
    ifConditionList &&
      ifConditionList.map((ifCondition) => {
        let t3 = Object.keys(ifCondition).map((cond) => {
          let test = ifCondition[cond];
          if (
            test &&
            test.RowType === 'CONDITION' &&
            test.Value === undefined &&
            test.Device === undefined &&
            test.Parameter === undefined
          ) {
            return false;
          } else if (test && test.RowType === 'RETURN' && !test.Value) {
            return false;
          } else if (
            (test && test.RowType === 'RETURN' && test.Value === undefined) ||
            !test.Value
          ) {
            return false;
          } else {
            return true;
          }
        });
        status = t3.includes(false);
        return undefined;
      });
    if (status === true) return false;
    else { return true; }
  };

  const saveCondition = async () => {
    let result = findCondition(ifConditionList);
    if (result === true) {
      let ifScriptList =
        ifConditionList &&
        ifConditionList.map((ifCondition, index) => {
          return {
            Script: generateScript(ifCondition),
            Priority: scripts[index].Priority
          };
        });
      const siteId = localStorage.get('currentSite');
      let payload = {
        Code: assetValue,
        Type: assetType,
        JSON: ifConditionList,
        Scripts: ifScriptList,
        SiteId: siteId
      };
      setScripts(ifScriptList);
      let saveResp = await saveLandingPageConfiguration(payload);
      if (saveResp && saveResp.message) {
        message.success(saveResp.message);
        setActiveKey('LIST');
        getList();
      }
    } else if (result === false) {
      message.error('please enter data');
    }
  };

  const editRecord = (record) => {
    let { JSON, Code, Type, Scripts } = record;
    setIfConditionList(JSON);
    setAssetValue(Code);
    setAssetType(Type);
    setScripts(Scripts);
    setActiveKey('DETAILS');
    // setEditObject(record);
  };

  const deleteRecord = async (record) => {
    let deleteResponse = await deleteStatusRecord(record.Code);
    if (deleteResponse && deleteResponse.message) {
      message.success(deleteResponse.message);
      getList();
    }
  };

  const onPriorityChange = (value, ifIndex) => {
    let newScripts = [...scripts];
    newScripts[ifIndex].Priority = value;
    setScripts(newScripts);
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name'
    },
    {
      title: 'Code',
      dataIndex: 'Code',
      key: 'Code'
    },
    {
      title: 'Actions',
      render: (text, record) => (
        <>
          <Button
            style={{ marginRight: '5px' }}
            className="ant-btn"
            onClick={() => editRecord(record)}

          >
            {' '}
            <Tooltip title={'Edit'}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Button
            style={{ marginRight: '5px' }}
            className="ant-btn"
            onClick={() => deleteRecord(record)}

          >
            {' '}
            <Tooltip title={'Delete'}>
              <DeleteOutlined />
            </Tooltip>
          </Button>
        </>
      )
    }
  ];

  return (
    <StyledHomepage>
      <Tabs activeKey={activeKey} onChange={(activeKey) => setActiveKey(activeKey)}>
        <Tabs.TabPane tab="List View" key="LIST">
          <StyledTable size="small"
            style={{ marginTop: '10px' }}
            columns={columns}
            dataSource={datasource}
            pagination={
              datasource.length > 10
                ? {
                  pageSize: '10'
                }
                : false
            }
          />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Details View" key="DETAILS">
          <div style={{ marginTop: '10px' }}>
            <Form.Item>
              <TreeSelect
                showSearch
                style={{ width: 350 }}
                value={assetValue}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder={'Select Asset'}
                allowClear={false}
                treeDefaultExpandAll
                onSelect={(assetValue, node) => {
                  setAssetType(node.type);
                  setAssetValue(assetValue);
                }}
              >
                {renderAssetTreeNodes(assetList)}
              </TreeSelect>
            </Form.Item>

            {ifConditionList &&
              ifConditionList.map((ifCondition, ifIndex) => {
                return (
                  <div
                    key={ifIndex}
                    style={{ padding: '10px',marginBottom: '10px',border:"1px solid grey" }}
                  >
                    {
                      <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                        <Button
                          type="danger"
                          icon={<DeleteOutlined />}
                          onClick={() => deleteIfCondition(ifIndex)}
                        />
                        <Input
                          style={{ width: '5%', marginRight: '5px' }}
                          value={scripts[ifIndex].Priority}
                          onChange={(e) => onPriorityChange(e.target.value, ifIndex)}
                        ></Input>
                      </div>
                    }

                    {ifCondition &&
                      Object.keys(ifCondition) &&
                      Object.keys(ifCondition).map((rowKey, index) => {
                        let ifCond = ifCondition[rowKey];
                        if (ifCond.RowType === 'CONDITION') {
                          return (
                            <>
                              <Condition
                                index={index}
                                rowKey={rowKey}
                                ifCond={ifCond}
                                ifIndex={ifIndex}
                                Operator={Operator}
                                assetValue={assetValue}
                                assetType={assetType}
                                HierarchyCode={HierarchyCode}
                                ifConditionList={ifConditionList}
                                ifCondition={ifCondition}
                                onSelectChange={(value, rowKey, ifIndex, key) =>
                                  onSelectChange(value, rowKey, ifIndex, key)
                                }
                                deleteCondition={(ifIndex) =>
                                  deleteCondition(ifIndex, index)
                                }
                                addNewCondition={(ifIndex) => addNewCondition(ifIndex)}
                              />
                            </>
                          );
                        } else if (ifCond.RowType === 'OPERATOR') {
                          return (
                            <div style={{ margin: '10px' }} key={index}>
                              <Select
                                defaultValue="AND"
                                placeholder={'Select operator'}
                                style={{ width: 170 }}
                                value={ifCond.Value}
                                onChange={(value) =>
                                  onSelectChange(value, rowKey, ifIndex, 'Value')
                                }
                                options={[
                                  {
                                    value: '&&',
                                    label: 'AND'
                                  },
                                  {
                                    value: '||',
                                    label: 'OR'
                                  }
                                ]}
                              />
                            </div>
                          );
                        } else {
                          return (
                            <div style={{ margin: '-7px 10px 10px 10px' }} key={index}>
                              <div style={{marginBottom: '3px' }}>THEN</div>
                              <Input
                                style={{ width: 170 }}
                                value={ifCond.Value}
                                placeholder="Input return value"
                                onChange={(e) =>
                                  onSelectChange(e.target.value, rowKey, ifIndex, 'Value')
                                }
                              />
                            </div>
                          );
                        }
                      })}
                    {ifConditionList.length - 1 === ifIndex ? (
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          onClick={addNewIfCodition}
                        >
                          {'Add another if condition'}
                        </Button>
                      </div>
                    ) : null}

                  </div>
                );
              })}

            <Button type="primary" onClick={() => saveCondition()}>
              Save
            </Button>
          </div>
        </Tabs.TabPane>
      </Tabs>
    </StyledHomepage>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(StatusConfiguration);
